import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { styles } from './formStyles';

const NoBetsBadge = ({ t, }) => {
  const classes = useStyles();
  return (
    <div className={classes.noBets}>
      <i className="material-icons header-menu-icon betting_icon">group</i>
      <span>{t('no_offers')}</span>
    </div>
  );
};

NoBetsBadge.propTypes = {
  t: PropTypes.func.isRequired,
};

const useStyles = createUseStyles({
  noBets: {
    backgroundColor: 'white',
    border: `1px solid ${styles.colors.blue}`,
    borderRadius: '4px',
    display: 'flex',
    padding: '0.8em',
    fontSize: '14px',
    alignItems: 'center',
    '& i': {
      color: styles.colors.blue,
      marginRight: '0.3em',
    },
    '& span': {
      color: styles.colors.dark,
    },
  },
});

export default NoBetsBadge;
